/** @module Auth0LoggerConsole */
/* eslint-disable import/extensions */
import Auth0LoggerBase from './auth0-logger-base.mjs';

class Auth0LoggerConsole extends Auth0LoggerBase {
  log(msg) {
    console.log(this._logMsgToString(msg));
    return Promise.resolve();
  }

  trace(msg) {
    console.trace(this._logMsgToString(msg));
    return Promise.resolve();
  }

  debug(msg) {
    console.debug(this._logMsgToString(msg));
    return Promise.resolve();
  }

  info(msg) {
    console.info(this._logMsgToString(msg));
    return Promise.resolve();
  }

  warn(msg) {
    console.warn(this._logMsgToString(msg));
    return Promise.resolve();
  }

  error(msg) {
    console.error(this._logMsgToString(msg));
    return Promise.resolve();
  }
}

export default Auth0LoggerConsole;
